import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import widgetService from 'live/services/widgets'
import { reducer } from './reducer'
import { Chart } from './Chart'
import Config from './Config'

export default widgetService.register({
    type: 'histogram',
    get name() {
        return 'Histogram Widget'
    },
    get description() {
        return ''
    },
    config: {
        // legend: { legendEnabled: true, legendRight: false }
    },
    //@ts-ignore
    ui: { configForm: Config },
    policies: {
        defaultReducer: '@latest',
        layers: 1,
        legends: true
    },
    impl: reactWidgetWrapper<ChartState, ChartMessage>(Chart, reducer)
})
